'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routingSelector = exports.LOCATION_CHANGE = exports.sagaEffects = undefined;

var _connectedReactRouter = require('connected-react-router');

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _connectedReactRouter.LOCATION_CHANGE;
  }
});

var _selectors = require('../../selectors');

Object.defineProperty(exports, 'routingSelector', {
  enumerable: true,
  get: function get() {
    return _selectors.routingSelector;
  }
});

var _effects = require('redux-saga/effects');

var sagaEffects = _interopRequireWildcard(_effects);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

exports.sagaEffects = sagaEffects;